import axios from '../axios'

/*
 * 菜单管理模块
 */

// 查询平台分类
export const selectPage = (data) => {
    return axios({
        url: '/admin/platformCategory/selectPage',
        method: 'post',
        data
    })
}

export const selectPlatformConfig = (params) => {
    return axios({
        url: '/admin/platformConfig/api/selectPlatformConfig',
        method: 'get',
        params
    })
}

export const platformConfigUpdate = (data) => {
    return axios({
        url: '/admin/platformConfig/update',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/platform.js